import { centerCrop, makeAspectCrop } from 'react-image-crop';
import moment from 'moment';

export const centerAspectCrop = (mediaWidth, mediaHeight, aspect) => centerCrop(
  makeAspectCrop(
    {
      unit: '%',
      width: 75,
      height: 75
    },
    aspect,
    mediaWidth,
    mediaHeight
  ),
  mediaWidth,
  mediaHeight,
);

export const canvasToBase64Image = async (image, crop) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('No 2d context');
  }

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  // devicePixelRatio slightly increases sharpness on retina devices
  // at the expense of slightly slower render times and needing to
  // size the image back down if you want to download/upload and be
  // true to the images natural size.
  const pixelRatio = window.devicePixelRatio;

  // eslint-disable-next-line no-param-reassign
  canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
  // eslint-disable-next-line no-param-reassign
  canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

  ctx.scale(pixelRatio, pixelRatio);
  ctx.imageSmoothingQuality = 'high';

  const cropX = crop.x * scaleX;
  const cropY = crop.y * scaleY;

  const centerX = image.naturalWidth / 2;
  const centerY = image.naturalHeight / 2;

  ctx.save();

  // 5) Move the crop origin to the canvas origin (0,0)
  ctx.translate(-cropX, -cropY);
  // 4) Move the origin to the center of the original position
  ctx.translate(centerX, centerY);

  // 1) Move the center of the image to the origin (0,0)
  ctx.translate(-centerX, -centerY);
  ctx.drawImage(
    image,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight,
  );
  ctx.restore();
  return ctx.canvas.toDataURL('image/jpeg');
};

export const blobToBase64 = (blob) => new Promise((resolve) => {
  const reader = new FileReader();
  reader.onloadend = () => resolve(reader.result);
  reader.readAsDataURL(blob);
});

export const ageCalculation = (a) => {
  const dob = new Date(a);
  const formattedDate = moment(dob).format('YYYY-MM-DD');
  const age = moment().diff(formattedDate, 'years');
  return age;
};

export const formCircleBtnNavLink = (history, dotNum) => {
  switch (dotNum) {
    case 0: history.push('/personal-info'); break;
    case 1: history.push('/insurance-info'); break;
    case 2: history.push('/primary-care-info'); break;
    case 3: history.push('/emergency-info'); break;
    default: history.push('/personal-info'); break;
  }
};
